<template>
  <div class="addModel">
    <div class="addfrom">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" labelPosition='left'>
        <el-row>
          <el-col :span="24">
            <el-form-item label="版本号：" prop="version">
              <el-input maxlength="100"  v-model="ruleForm.version"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="规范文件：">
              <el-upload
                class="avatar-uploade"
                :action="uploadUrl"
                :on-change="handleChange"
                :file-list="files"
                :multiple="false"
                :auto-upload="false"
              >
                <el-button>选取文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class='footer'>
        <el-button v-waves class="mybtny" @click="submit">保存</el-button>
        <el-button v-waves class="mybtny" @click="resetForm">重置</el-button>
        <el-button v-waves class="mybtnn" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/util/request';
export default {
  props:['editData'],
  data() {
    return {
      ruleForm: {
        version: '',
        fileName: '',
        filePath: '',
      },
      rules: {
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' }
        ],
      },
      files: [],
      uploadUrl: "/admin/sys-file/upload", //上传地址
    };
  },
  created() {
    if (this.editData) {
      this.ruleForm = this.editData
      if (this.editData.filePath) {
        this.files = [
          {
            name: this.editData.fileName,
            url: this.editData.filePath,
            uid: this.editData.id,
          }
        ];
      }
      else {
        this.files = [];
      }
    }
  },
  methods: {
    submit() {
      let that = this;
      that.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (that.files.length > 0) {
            let fileObj = that.files[0].raw;
            const form = new FormData();
            form.append("file", fileObj);
            axios({
              url: that.uploadUrl,
              headers: { 'Content-Type': 'multipart/form-data' },
              method: 'post',
              data: form
            }).then(res => {
              if (res.succeed) {
                that.ruleForm.fileName = that.files[0].name;
                that.ruleForm.filePath = res.data.fileName;
                that.$emit("submit", that.ruleForm, false);
              }
              else {
                if (res.code === '401') {
                  that.$message.error('登录过期，请重新登录！');
                  setTimeout(()=>{
                    window.sessionStorage.clear();
                    window.localStorage.clear();
                    window.location.href= "/login";
                  },1000);
                  that.$message.destroyed();
                  return false;
                }
                else {
                  that.ruleForm.fileName = '';
                  that.ruleForm.filePath = '';
                  that.files = [];
                  that.$message.error(res.msg);
                }
              }
            }).catch((data) => {
              that.ruleForm.fileName = '';
              that.ruleForm.filePath = '';
              that.files = [];
              that.$message.error("上传失败,请重新上传文件!");
            });
          }
          else {
            that.$emit("submit", that.ruleForm, false);
          }
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    handleChange(file, fileList) {
      this.files = fileList.slice(-1);
    },
  },
}
</script>

<style lang='less' scoped>
.addModel {
  .addfrom {
    margin: 0 30px;
    .topcontent {
      margin-bottom: 20px;
      .el-row {
        margin-bottom: 0;
        height: 40;
      }
      p {
        padding: 0 10px;
      }
    }
    .el-row {
      margin-bottom: 22px;
      &:last-child {
        // margin-bottom: 0;
      }
      /deep/.el-input__inner {
        height: 33px;
        width: 80%;
      }
      /deep/.el-select {
        width: 160px;
        /deep/.el-input__inner {
          width: 100%;
        }
      }
      .el-col-7,.el-col-8,.el-col-9 {
        height: 32px;
      }
      /deep/.el-form-item {
        margin-bottom: 10px;
      }
      /deep/.el-form-item__label {
        padding: 0;
      }
    }
  }
  /deep/.el-button {
    width: 100px;
  }
  .footer {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/StandardMana/components/editVersion.vue